import { UserTrial } from '@bn/auth/stores/helpers';
import { UserLimits } from '@bn/mc-api/v3';

/** From User product limits & trial conditions set one limits truth */
export const getMagicContainerUserProductLimits: (mcLimits: UserLimits | null, trial: UserTrial | null) => MagicContainerUserProductLimitsType = (
  mcLimits,
  trial = null,
) => {
  const regionsMaxScaling = 10;
  const maxTrialBaseRegions = 5;

  // Return some defaults, like if trial is not enabled
  if (!mcLimits && !trial)
    return {
      areLimitsLoaded: false,
      blockActiveRegionsLimitToggleFormChange: false,
      applications: {
        current: -1,
        max: -1,
      },
      maxBaseRegionsPerApp: 10,
      maxPodsPerApp: null,
      maxRegionsPerApp: null,
      maxVolumesPerApp: null,
      maxVolumeSize: null,
      regionsMaxScaling,
    };

  /**
   * ## Partial specs: DASH-1848 Behavior:
   * If `limits.maxNumberOfRegionsPerApplication` is not null:
   * 1. The user cannot disable the "Limit number of active regions" toggle.
   * 2. The user cannot increase the maximum number of active regions beyond `limits.maxNumberOfRegionsPerApplication`.
   * 3. The user can decrease the maximum number of active regions.
   * 4. Validations for `maximum < numberOfEnabledRegions` remain unchanged.
   *
   * If `limits.maxNumberOfRegionsPerApplication` is null:
   * - The old logic is retained, and no new constraints are applied.
   */
  return {
    areLimitsLoaded: true,
    blockActiveRegionsLimitToggleFormChange: !!mcLimits?.maxNumberOfRegionsPerApplication,
    applications: {
      current: mcLimits?.existingNumberOfApplications ?? -1,
      max: mcLimits?.maxNumberOfApplications ?? -1,
    },
    maxBaseRegionsPerApp: (trial?.inProgress ? maxTrialBaseRegions : mcLimits?.maxNumberOfRegionsPerApplication) ?? null,
    maxPodsPerApp: mcLimits?.maxNumberOfInstancesPerApplication ?? null,
    maxRegionsPerApp: mcLimits?.maxNumberOfRegionsPerApplication ?? null,
    maxVolumesPerApp: mcLimits?.maxNumberOfVolumesPerApplication ?? null,
    maxVolumeSize: mcLimits?.maxVolumeSize ?? null,
    regionsMaxScaling: mcLimits?.maxNumberOfInstancesPerRegion ?? regionsMaxScaling,
  };
};

export type MagicContainerUserProductLimitsType = {
  areLimitsLoaded: boolean;
  blockActiveRegionsLimitToggleFormChange: boolean;
  applications: {
    current: number;
    max: number;
  };
  maxBaseRegionsPerApp: number | null;
  maxPodsPerApp: number | null;
  maxRegionsPerApp: number | null;
  maxVolumesPerApp: number | null;
  maxVolumeSize: number | null;
  regionsMaxScaling: number;
};
